import { useEffect, useState } from "react";

import CrudModal from "components/crud/CrudModal";
import CrudInput from "components/crud/CrudInput";

import {
    createSampleConversion,
} from "services/api/sampleTrackingApi";

import {
    showSuccess,
    showError,
} from "utils/toast";


export default function ConversionModal({
    open,
    onClose,
    reload,
    item,
}) {

    const [
        loading,
        setLoading,
    ] = useState(false);


    const [
        form,
        setForm,
    ] = useState({

        conversionDate: "",
        quantity: 1,
        orderReference: "",
        orderAmount: "",
        remarks: "",

    });


    useEffect(
        () => {

            if (!open) {
                return;
            }


            setForm({

                conversionDate:
                    new Date()
                        .toISOString()
                        .substring(
                            0,
                            10
                        ),

                quantity: 1,

                orderReference:
                    "",

                orderAmount:
                    "",

                remarks:
                    "",

            });

        },
        [
            open,
        ]
    );


    const handleChange =
        (e) => {

            const {
                name,
                value,
            } = e.target;


            setForm(
                (prev) => ({
                    ...prev,
                    [name]:
                        value,
                })
            );
        };


    const remaining =
        Number(
            item?.summary?.remainingQuantity ||
            0
        );


    const handleSubmit =
        async (e) => {

            e.preventDefault();


            if (
                Number(
                    form.quantity
                ) < 1
            ) {

                showError(
                    "Quantity must be at least 1."
                );

                return;
            }


            if (
                Number(
                    form.quantity
                ) > remaining
            ) {

                showError(
                    `Only ${remaining} sample(s) are available for conversion.`
                );

                return;
            }


            try {

                setLoading(
                    true
                );


                await createSampleConversion(
                    item.id,
                    {

                        conversionDate:
                            form.conversionDate,

                        quantity:
                            Number(
                                form.quantity
                            ),

                        orderReference:
                            form.orderReference ||
                            undefined,

                        orderAmount:
                            form.orderAmount ||
                            undefined,

                        remarks:
                            form.remarks ||
                            undefined,

                    }
                );


                showSuccess(
                    "Sample conversion recorded successfully."
                );


                await reload();

                onClose();

            } catch (
                error
            ) {

                showError(
                    error?.response?.data?.message ||
                    "Unable to record conversion."
                );

            } finally {

                setLoading(
                    false
                );

            }

        };


    if (!open) {
        return null;
    }


    return (

        <CrudModal

            open={open}

            title="Record Sample Conversion"

            loading={loading}

            submitText="Record Conversion"

            onClose={onClose}

            onSubmit={handleSubmit}

            width="max-w-2xl"

        >

            <div
                className="
                    mb-5
                    rounded-xl
                    bg-green-50
                    p-4
                "
            >

                <div
                    className="
                        text-sm
                        text-gray-600
                    "
                >
                    Available for conversion
                </div>

                <div
                    className="
                        mt-1
                        text-2xl
                        font-bold
                        text-green-700
                    "
                >
                    {remaining}
                </div>

            </div>


            <div
                className="
                    grid
                    grid-cols-1
                    gap-5
                    md:grid-cols-2
                "
            >

                <CrudInput
                    label="Conversion Date"
                    type="date"
                    name="conversionDate"
                    value={
                        form.conversionDate
                    }
                    onChange={
                        handleChange
                    }
                />


                <CrudInput
                    label="Quantity"
                    type="number"
                    min="1"
                    max={
                        remaining
                    }
                    name="quantity"
                    value={
                        form.quantity
                    }
                    onChange={
                        handleChange
                    }
                />


                <CrudInput
                    label="Order Reference"
                    name="orderReference"
                    value={
                        form.orderReference
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="ORD-00125"
                />


                <CrudInput
                    label="Order Amount"
                    type="number"
                    min="0"
                    step="0.01"
                    name="orderAmount"
                    value={
                        form.orderAmount
                    }
                    onChange={
                        handleChange
                    }
                    placeholder="18000.00"
                />

            </div>


            <div className="mt-5">

                <CrudInput
                    label="Remarks"
                    name="remarks"
                    value={
                        form.remarks
                    }
                    onChange={
                        handleChange
                    }
                />

            </div>

        </CrudModal>
    );
}